module.exports = __webpack_public_path__ + "img/SL-M-240-290.b8cd8af2.svg";